import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

export enum RuntimeConfig {
  DEFAULT,
  DISTRIBUTION,
  PG, // P&G Everyday
  SDE,
}

export default function useConfig() {
  const router = useRouter();
  const [runtime, setRuntime] = useState<RuntimeConfig>(RuntimeConfig.DEFAULT);

  useEffect(() => {
    if (router.pathname === '/dist') {
      setRuntime(RuntimeConfig.DISTRIBUTION);
    } else if (router.query.sde) {
      setRuntime(RuntimeConfig.SDE);
    }
  }, [router]);

  return { runtime };
}

export function isRuntimeSDE() {
  const { runtime } = useConfig();
  return runtime === RuntimeConfig.SDE;
}
